var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiConversations01 = function SvgAiConversations01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_conversations-01_svg2__a",
    x1: 1.23,
    x2: 174.03,
    y1: 163.8,
    y2: 38.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ai_conversations-01_svg2__a",
    id: "ai_conversations-01_svg2__b",
    x1: -27.09,
    x2: 145.71,
    y1: 124.77,
    y2: -0.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ai_conversations-01_svg2__a",
    id: "ai_conversations-01_svg2__c",
    x1: -13.35,
    x2: 159.45,
    y1: 143.72,
    y2: 18.35
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.96 7.76C6.32 7.76 0 14.08 0 21.72v79.14c0 7.64 6.32 13.96 13.96 13.96h13.57v29.05a5.36 5.36 0 0 0 9.52 3.38l21.46-26.4v23.02c0 7.64 6.32 13.96 13.96 13.96h64.13l26.36 32.43a5.364 5.364 0 0 0 7.54.78 5.36 5.36 0 0 0 1.98-4.16v-29.05h13.57c7.64 0 13.96-6.32 13.96-13.96V64.73c0-7.64-6.32-13.96-13.96-13.96h-44.54V21.72c0-7.64-6.32-13.96-13.96-13.96zm0 10.71h113.57c1.89 0 3.25 1.36 3.25 3.25v79.14c0 1.88-1.36 3.25-3.25 3.25H60.85c-1.61 0-3.14.73-4.16 1.98l-18.45 22.7v-19.32c0-2.96-2.4-5.36-5.36-5.36H13.96c-1.89 0-3.25-1.36-3.25-3.25V21.72c0-1.89 1.35-3.25 3.25-3.25M141.5 61.49h44.54c1.89 0 3.25 1.35 3.25 3.25v79.14c0 1.89-1.36 3.25-3.25 3.25h-18.93a5.36 5.36 0 0 0-5.36 5.36v19.32l-18.45-22.7a5.36 5.36 0 0 0-4.16-1.98H72.46c-1.9 0-3.25-1.35-3.25-3.25v-29.05h58.31c7.64 0 13.96-6.32 13.96-13.96V61.5Z",
    style: {
      fill: "url(#ai_conversations-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.51 34.64A5.36 5.36 0 0 0 40.15 40v43.11a5.36 5.36 0 0 0 10.72 0V71.74h18.21V83.2a5.36 5.36 0 0 0 10.72 0V40c0-2.96-2.4-5.36-5.36-5.36H45.52Zm5.36 10.72h18.21v15.67H50.87z",
    style: {
      fill: "url(#ai_conversations-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.91 34.64A5.36 5.36 0 0 0 94.55 40v43.11a5.36 5.36 0 0 0 10.72 0V40c0-2.96-2.4-5.36-5.36-5.36",
    style: {
      fill: "url(#ai_conversations-01_svg2__c)"
    }
  }));
};
export default SvgAiConversations01;